import { api } from "@/shared/api";
import { brandRows } from "@/shared/brand/persona";

import type { CapabilityCard } from "../model/types";

/**
 * 能力舱卡片(挂了 cluster 的舱)—— 唯一来源 = 后端 xb_module_catalog(经 /me/modules/capabilities)。
 * 首页 5 群卡墙 / 上下文侧栏能力区 / ⌘K 命令面板共用;运营改归组·加舱·转态零前端发版。
 */
export const capabilityService = {
  // 1004 O5:目录名 / 简介按直营人设写死(经营看板简介、advisor 能力名),渠道租户要换成当前品牌人设。
  listCapabilities: () =>
    api
      .get<CapabilityCard[]>("/me/modules/capabilities")
      .then((rows) => brandRows(rows, "displayName", "description")),
};
